"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Label_1 = require("./Label");
var mobx_react_1 = require("mobx-react");
var react_google_recaptcha_1 = __importDefault(require("react-google-recaptcha"));
var styles = __importStar(require("./Captcha.module.css"));
var Captcha = (function (_super) {
    __extends(Captcha, _super);
    function Captcha() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Captcha.prototype.componentDidMount = function () {
    };
    Captcha.prototype.render = function () {
        var _a = this.props, errors = _a.errors, onChange = _a.onChange, recaptchaRef = _a.recaptchaRef;
        return (react_1.default.createElement("div", { className: styles.checkBoxWrapper },
            react_1.default.createElement(Label_1.Label, { text: "", error: errors["captcha_value"], required: true },
                react_1.default.createElement(react_google_recaptcha_1.default, { sitekey: "" + process.env.APP_CAPTCHA_KEY, size: "normal", render: "explicit", ref: recaptchaRef, onChange: function (value) {
                        onChange("captcha_value", value);
                    }, onExpired: function () {
                        onChange("captcha_value", null);
                        recaptchaRef.current.reset();
                    } }))));
    };
    Captcha = __decorate([
        mobx_react_1.observer
    ], Captcha);
    return Captcha;
}(react_1.Component));
exports.Captcha = Captcha;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ2FwdGNoYS5qcyIsInNvdXJjZVJvb3QiOiIuLyIsInNvdXJjZXMiOlsicGRmL2NvbXBvbmVudHMvQ2FwdGNoYS9DYXB0Y2hhLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsNkNBQXFEO0FBQ3JELGlDQUE2QjtBQUM3Qix5Q0FBbUM7QUFDbkMsa0ZBQThDO0FBQzlDLDJEQUE4QztBQVk5QztJQUE2QiwyQkFBZ0I7SUFBN0M7O0lBZ0NBLENBQUM7SUEvQkcsbUNBQWlCLEdBQWpCO0lBSUEsQ0FBQztJQUVNLHdCQUFNLEdBQWI7UUFDVSxJQUFBLGVBQTZDLEVBQTVDLGtCQUFNLEVBQUUsc0JBQVEsRUFBRSw4QkFBMEIsQ0FBQTtRQUduRCxPQUFPLENBQ0gsdUNBQUssU0FBUyxFQUFFLE1BQU0sQ0FBQyxlQUFlO1lBQ2xDLDhCQUFDLGFBQUssSUFBQyxJQUFJLEVBQUMsRUFBRSxFQUFDLEtBQUssRUFBRSxNQUFNLENBQUMsZUFBZSxDQUFDLEVBQUUsUUFBUTtnQkFDbkQsOEJBQUMsZ0NBQVMsSUFDTixPQUFPLEVBQUUsS0FBRyxPQUFPLENBQUMsR0FBRyxDQUFDLGVBQWlCLEVBQ3pDLElBQUksRUFBQyxRQUFRLEVBQ2IsTUFBTSxFQUFDLFVBQVUsRUFDakIsR0FBRyxFQUFFLFlBQVksRUFDakIsUUFBUSxFQUFFLFVBQUMsS0FBSzt3QkFDWixRQUFRLENBQUMsZUFBZSxFQUFFLEtBQUssQ0FBQyxDQUFBO29CQUNwQyxDQUFDLEVBQ0QsU0FBUyxFQUFFO3dCQUNQLFFBQVEsQ0FBQyxlQUFlLEVBQUUsSUFBSSxDQUFDLENBQUE7d0JBQy9CLFlBQVksQ0FBQyxPQUFPLENBQUMsS0FBSyxFQUFFLENBQUE7b0JBQ2hDLENBQUMsR0FFSCxDQUNFLENBQ04sQ0FDVCxDQUFBO0lBQ0wsQ0FBQztJQS9CUSxPQUFPO1FBRG5CLHFCQUFRO09BQ0ksT0FBTyxDQWdDbkI7SUFBRCxjQUFDO0NBQUEsQUFoQ0QsQ0FBNkIsaUJBQVMsR0FnQ3JDO0FBaENZLDBCQUFPIn0=